import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Modal from "react-modal";
import "react-responsive-carousel/lib/styles/carousel.min.css";

// components
import backgroundImage from "../../../components/images/referral_ad.jpg";
import digitalSkillsTrainingBanner from "../../../components/images/digital-skills-training-banner.jpg";
import { HomeCarousel } from "../../../components/pulseHome";
import { OfferAlertModal } from "../../../components/loyalty";

//components
import {
  CurveHolder,
  StyledText,
  Button,
} from "../../../components/common/basic";
import { CloseIcon, Curve, ProfileIcon } from "../../../components/svgs";

// context
import TakeSurveyModal from "../eventSurvey/components/TakeSurveyModal";

//gif
import loadingGif from "../../../components/images/loader.gif";
import useHome from "./hooks/useHome";
import OptInRequestModal from "./components/OptInRequestModal";
import NotificationBellIcon from "../../../components/svgs/notificationBellIcon";
import useNewFeatureUpdate from "../NotificationScreen/hooks/useNewFeatureUpdate";
import DigitalSkillsBanner from "../digitalskillstraining/components/DigitalSkillsBanner";
import NewNotificationModal from "./components/NewNotificationModal";
import TaskResumptionModal from "../../../components/common/TaskResumptionModal";

const SubscriberHome = () => {
  const {
    loyaltyOffersData,
    setSelectedLoyaltyData,
    offerModal,
    setOfferModal,
    isTakeSurveyModalOpen,
    fastestFingerData,
    userProfilephoto,
    isFetchingUserProfile,
    background,
    mashupBackground,
    foundElement,
    isModalOpen,
    setIsModalOpen,
    changeOfferTab,
    history,
    offers,
    handleCloseTakeSurveyModal,
    interactionID,
    surveyCode,
    showPointStatsModal,
    setShowPointStatsModal,
    isOpenOptInRequestDialog,
    onCloseOptInRequestDialog,
    unreadCount,
    isNewNotificationDialog,
    onCloseisNewNotificationDialog,
    trackAndNavigate,
    showTaskResumptionModal,
    setShowTaskResumptionModal,
  } = useHome();

  return (
    <>
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
          style={{
            overlay: {
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1,
            },
            content: {
              marginTop: 100,
              alignSelf: "center",
              height: "350px",
              flexDirection: "column",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "white",
              borderRadius: "20px",
            },
          }}
        >
          <CloseIconContainer onClick={() => setIsModalOpen(false)}>
            <CloseIcon fill="white" width={21} />
          </CloseIconContainer>
          <ModalImage src={backgroundImage} />
          <ModalBody>
            <StyledText
              size={20}
              color={"#000"}
              style={{
                marginTop: 5,
                textAlign: "center",
                fontFamily: "MTNRegular",
                fontWeight: "bold",
              }}
            >
              Refer & Earn on Pulse
            </StyledText>
            <StyledText
              size={14}
              color={"#000"}
              style={{
                textAlign: "center",
                fontFamily: "MTNRegular",
                marginTop: -15,
              }}
            >
              Share your referral code with family and friends and earn
              redeemable points every time they make a purchase
            </StyledText>

            <Button
              style={{ backgroundColor: "#e31c79", color: "#fff" }}
              onClick={() => history.push(`/referral`)}
            >
              <StyledText>Refer & earn</StyledText>
            </Button>
          </ModalBody>
        </Modal>
      )}
      <MainHolder activeTheme={mashupBackground}>
        <Preloader hide={loyaltyOffersData?.length > 0} />
        <Children>
          {offerModal !== null && (
            <OfferAlertModal
              background={background}
              title={offerModal?.title}
              description={offerModal?.description}
              hideModal={() => {
                setOfferModal(null);
              }}
            />
          )}

          <ContentContainer
            style={{
              display: loyaltyOffersData?.length > 0 ? "block" : "none",
            }}
          >
            <HeaderContent activeTheme={"white"}>
              <OfferHeader>
                <img
                  alt="Pulse Logo"
                  width={100}
                  src={`${SERVER_URL}/assets/images/pulse_logo.png`}
                />
                <div
                  style={{
                    display: "flex",
                    alignSelf: "center",
                    gap: "10px",
                  }}
                >
                  <ProfileButton
                    onClick={() =>
                      trackAndNavigate(
                        "notifications_button_clicked",
                        "/notifications"
                      )
                    }
                  >
                    <NotificationBellIcon notifications={unreadCount} />
                  </ProfileButton>

                  <ProfileButton
                    onClick={() => {
                      history.push("/profile");
                    }}
                  >
                    {userProfilephoto ? (
                      <img
                        alt="User Profile"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        src={userProfilephoto}
                      />
                    ) : (
                      <ProfileIcon />
                    )}
                  </ProfileButton>
                </div>
              </OfferHeader>

              <div
                style={{
                  width: "90%",
                  marginTop: 30,
                  display: "flex",
                  alignSelf: "center",
                }}
              >
                {fastestFingerData && !true && (
                  <div>
                    <div
                      style={{
                        backgroundColor: background,
                        // width: 100,
                        zIndex: 100,
                        marginTop: 80,
                        marginLeft: 20,
                        paddingInline: 10,
                        paddingTop: 5,
                        paddingBottom: 5,
                        position: "absolute",
                      }}
                    >
                      <StyledText style={{ margin: 0, color: "white" }}>
                        Ends in 12:04
                      </StyledText>
                    </div>

                    <div
                      style={{
                        zIndex: 100,
                        marginTop: 120,
                        marginLeft: 10,
                        paddingInline: 10,
                        paddingTop: 5,
                        paddingBottom: 5,
                        position: "absolute",
                      }}
                    >
                      <StyledText
                        style={{ margin: 0, fontSize: 24, color: "white" }}
                      >
                        Fastest Finger
                      </StyledText>
                      <StyledText
                        style={{
                          margin: 0,
                          fontFamily: "MTNRegular",
                          color: "white",
                        }}
                      >
                        Be the fastest and win free airtime!
                      </StyledText>
                    </div>
                  </div>
                )}
                <HomeCarousel setData={setSelectedLoyaltyData} />
              </div>
            </HeaderContent>
            {isFetchingUserProfile ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  alt={"Loading offers"}
                  src={loadingGif}
                  style={{
                    width: "150px",
                    marginBottom: "20px",
                  }}
                />
                <StyledText
                  style={{
                    margin: 0,
                    fontFamily: "MTNRegular",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  Checking for available offers, please wait...
                </StyledText>
              </div>
            ) : (
              <>
                <CurveHolder>
                  <Curve fill={mashupBackground} />
                </CurveHolder>
                <OffersContainer activeTheme={mashupBackground}>
                  <div
                    style={{
                      flexDirection: "row",
                      overflowX: "auto",
                      whiteSpace: "nowrap",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                      msOverflowStyle: "none",
                    }}
                  >
                    {offers.map((tab) => (
                      <button
                        key={tab.id}
                        style={{
                          border: `1px solid ${background}`,
                          borderRadius: 5,
                          paddingLeft: "20px",
                          paddingRight: "20px",
                          paddingTop: "8px",
                          paddingBottom: "8px",
                          marginRight: 10,
                          fontFamily: "MTNMedium, sans-serif",
                          background: tab.isActive ? background : "transparent",
                          color: tab.isActive ? "white" : background,
                        }}
                        onClick={() => changeOfferTab(tab.id)}
                      >
                        {tab.name}
                      </button>
                    ))}
                  </div>
                  <div key={foundElement?.id}>{foundElement?.element}</div>
                </OffersContainer>
              </>
            )}
          </ContentContainer>
        </Children>

        <TakeSurveyModal
          isOpen={isTakeSurveyModalOpen}
          onClose={handleCloseTakeSurveyModal}
          interactionID={interactionID}
          surveyCode={surveyCode}
        />
        {/* //! REMOVE ASSOCIATED LOGIC IN USEHOME */}

        <NewNotificationModal
          isOpen={isNewNotificationDialog}
          onClose={onCloseisNewNotificationDialog}
          viewNotifications={() =>
            trackAndNavigate("peerTalk_tuesday-10-06-25_prompt", "/peer_talk")
          }
        />

        {loyaltyOffersData?.length > 0 && (
          <TaskResumptionModal
            isOpen={showTaskResumptionModal}
            onClose={() => setShowTaskResumptionModal(false)}
            title="Resume Task"
            message="You have an unfinished task. Do you want to continue?"
          />
        )}
      </MainHolder>
    </>
  );
};

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;
const Preloader = ({ hide }) => (
  <div
    style={{
      display: hide ? "none" : "flex",
      alignItems: "center",
      height: "100vh",
      background: "#FFCC00",
      position: "relative",
      boxSizing: "border-box",
      width: "100%",
      justifyContent: "center",
    }}
  >
    <div style={{ textAlign: "center" }}>
      <img
        alt="Pulse Logo"
        style={{ display: "block", width: "200px", marginBottom: "10px" }}
        src={`${SERVER_URL}/assets/images/pulse-logo-yellow.png`}
      />
      <img
        alt="Loader"
        style={{ width: "70px" }}
        src={`${SERVER_URL}/assets/images/loading.gif`}
      />
    </div>
  </div>
);

const MainHolder = styled.div`
  display: grid;
  align-content: space-between;
  grid-template-rows: auto auto 1fr;
  overflow: hidden;
  scrollbar-width: none;
  /* background-color: ${({ activeTheme }) => activeTheme}; */
  background-color: ${({ activeTheme }) => activeTheme};
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const ContentContainer = styled.div``;

const HeaderContent = styled.div`
  display: flex;
  align-content: center;
  background-color: ${({ activeTheme }) => activeTheme};
  flex-direction: column;
  width: 100%;
  padding-bottom: 25px;
  height: 300px;
`;

const OffersContainer = styled.div`
  display: flex;
  align-content: center;
  background-color: ${({ activeTheme }) => activeTheme};
  flex-direction: column;
  /* width: 300px; */
  padding-bottom: 25px;
  /* padding-inline: 10px; */
`;

const OfferHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  padding-top: 10px;
  padding-inline: 15px;
`;

const ProfileButton = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 15px;
  overflow: hidden;
  background-color: white;
  justify-content: center;
  align-content: center;
  display: grid;
  background-color: #333333;
`;

const CloseIconContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 20px;
`;

const ModalImage = styled.img`
  width: 310px;
  height: 180px;
  object-fit: cover;
  object-position: 80% 100%;
  border-radius: 20px;
  margin-top: -20px;
`;

const ModalBody = styled.div`
  max-width: 320px;
  margin-right: 20px;
  justify-content: center;
`;

export default SubscriberHome;
